import { API_URL } from '../config';

// Valores predeterminados para cuando el backend no devuelve datos válidos
const DEFAULT_CONFIG = {
  sendy: {
    generalListId: 'general',
    upcomingListId: 'lanzamientos',
    productsListId: 'productos',
    boardgamesListId: 'boardgames'
  }
};

// Función para enmascarar información sensible en logs
const maskSensitiveData = (data) => {
  if (typeof data !== 'object') return '[REDACTED]';
  
  const maskedData = { ...data };
  const sensitiveKeys = ['apiKey', 'secret', 'password', 'token', 'key', 'listId', 'generalListId', 'upcomingListId'];
  
  Object.keys(maskedData).forEach(key => {
    if (sensitiveKeys.some(sensitiveKey => key.toLowerCase().includes(sensitiveKey.toLowerCase()))) {
      maskedData[key] = '[REDACTED]';
    } else if (typeof maskedData[key] === 'object') {
      maskedData[key] = maskSensitiveData(maskedData[key]);
    }
  });
  
  return maskedData;
};

// Función segura para logging
const safeLog = (message, data) => {
  if (data) {
    console.log(message, maskSensitiveData(data));
  } else {
    console.log(message);
  }
};

// Cache para la configuración
let cachedConfig = null;

// Función para obtener la configuración del backend
export const getPublicConfig = async () => {
  try {
    safeLog('Intentando obtener configuración de:', `${API_URL}/config/public`);
    const response = await fetch(`${API_URL}/config/public`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Origin': window.location.origin
      }
    });
    
    if (!response.ok) {
      safeLog('Error en la respuesta del servidor, usando valores predeterminados');
      return DEFAULT_CONFIG;
    }
    
    const data = await response.json();
    safeLog('Configuración recibida del backend:', data);
    
    cachedConfig = {
      sendy: {
        generalListId: data.sendy?.generalListId || DEFAULT_CONFIG.sendy.generalListId,
        upcomingListId: data.sendy?.upcomingListId || DEFAULT_CONFIG.sendy.upcomingListId,
        productsListId: data.sendy?.productsListId || DEFAULT_CONFIG.sendy.productsListId,
        boardgamesListId: data.sendy?.boardgamesListId || DEFAULT_CONFIG.sendy.boardgamesListId
      }
    };
    
    return cachedConfig;
  } catch (error) {
    safeLog('Error al obtener configuración:', { error: error.message });
    safeLog('Usando configuración predeterminada debido a error');
    return DEFAULT_CONFIG;
  }
};

// Función para obtener configuración cacheada o nueva
const getCachedConfig = async () => {
  if (!cachedConfig) {
    return await getPublicConfig();
  }
  return cachedConfig;
};

// Función para obtener un valor específico de la configuración
export const getConfigValue = async (section, key) => {
  try {
    const config = await getCachedConfig();
    return config[section]?.[key] || DEFAULT_CONFIG[section]?.[key];
  } catch (error) {
    console.error(`Error al obtener configuración ${section}.${key}:`, error);
    return DEFAULT_CONFIG[section]?.[key];
  }
};

// Función para obtener los IDs de listas de Sendy
export const getSendyListIds = async () => {
  try {
    const config = await getCachedConfig();
    safeLog('IDs de lista cargados:', config);
    return {
      generalListId: config.sendy?.generalListId || DEFAULT_CONFIG.sendy.generalListId,
      upcomingListId: config.sendy?.upcomingListId || DEFAULT_CONFIG.sendy.upcomingListId,
      productsListId: config.sendy?.productsListId || DEFAULT_CONFIG.sendy.productsListId,
      boardgamesListId: config.sendy?.boardgamesListId || DEFAULT_CONFIG.sendy.boardgamesListId
    };
  } catch (error) {
    safeLog('Error al obtener IDs de listas Sendy:', error);
    return DEFAULT_CONFIG.sendy;
  }
};
